import ClubBasicInfo from './ClubBasicInfo';

export default ClubBasicInfo;
